/**
 * @generated SignedSource<<21ba7ee88209af683660661438b74e21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary$data = {
  readonly dailyTeamSchedule: {
    readonly events: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"useNowIndexes_teamScheduleEventOccasion">;
    }>;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentList_teamSchedule" | "WidgetTeamScheduleContentSectionHeader_teamSchedule">;
  };
  readonly monthlyTeamSchedule: {
    readonly events: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentSectionHeader_teamSchedule">;
  };
  readonly weeklyTeamSchedule: {
    readonly events: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentSectionHeader_teamSchedule">;
  };
  readonly " $fragmentType": "WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary";
};
export type WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary$key = {
  readonly " $data"?: WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "WidgetTeamScheduleContentSectionHeader_teamSchedule"
},
v2 = [
  {
    "kind": "Literal",
    "name": "includeInlineRoutines",
    "value": true
  }
],
v3 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "alias": null,
    "args": (v2/*: any*/),
    "concreteType": null,
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      (v0/*: any*/)
    ],
    "storageKey": "events(includeInlineRoutines:true)"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "dailyTeamSchedule",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamScheduleContentList_teamSchedule"
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "events",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useNowIndexes_teamScheduleEventOccasion"
            }
          ],
          "storageKey": "events(includeInlineRoutines:true)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "weeklyTeamSchedule",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "monthlyTeamSchedule",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    }
  ],
  "type": "WidgetTeamScheduleContentSummary",
  "abstractKey": null
};
})();

(node as any).hash = "fb3d26338432ebfffceec6fa4d377a85";

export default node;
